// extracted by mini-css-extract-plugin
module.exports = {"spinner":"SignUpEnrollment_spinner__3l_Is"};